import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import './styles.scss';

import RouterWrapper from './containers/RouterWrapper/RouterWrapper';
import store from './store/store';


// eslint-disable-next-line
class FormPage extends React.Component {
  render() {
    return (
      <RouterWrapper />
    );
  }
}

ReactDOM.render(
  <Provider store={store}>
    <FormPage />
  </Provider>,
  document.getElementById('order-form'),
);


if (module.hot) {
  module.hot.accept();
}
